export { default as VoucherDetails } from './VoucherDetails.container';
export { default } from './VoucherDetails';
